import { Link } from 'react-router';
import { ShieldOff } from 'lucide-react';
import { Button } from '@/shared/components/Button';
import styles from './ErrorPage.module.css';

export function AccessDeniedPage() {
  return (
    <div className={styles.wrapper}>
      <ShieldOff size={64} strokeWidth={1.5} className={styles.icon} />
      <h1 className={styles.code}>403</h1>
      <p className={styles.title}>Acesso negado</p>
      <p className={styles.description}>
        Você não tem permissão para acessar esta página.
      </p>
      <Link to="/">
        <Button variant="primary">Voltar ao início</Button>
      </Link>
    </div>
  );
}
